import type {
  IErrorApiResponse,
  ISuccessApiResponse,
  IValidationError,
} from '@wyz/types';
import { UseMutationOptions, restrictApi, useMutation } from '@wyz/utils';
import { useApi, useConfig } from '~/common/context';
import { CommonErrorCodesEnumType } from '~/common/types';
import { ConnectQueryKeys } from '~/connect/api';
import { JOBS_ENDPOINT } from '~/connect/schemas';
import { IImportPayload } from '~/connect/types';

type Options = {
  create?: UseMutationOptions<
    ISuccessApiResponse,
    IErrorApiResponse<IValidationError, CommonErrorCodesEnumType>,
    IImportPayload
  >;
};

export const useManageJobs = <
  TRequestedKeys extends keyof Options,
  TRequestedOptions extends Options = Pick<Options, TRequestedKeys>,
>(
  options: TRequestedOptions,
) => {
  const { callCoreApi } = useApi();
  const { tenantCode } = useConfig();

  const createMutation = useMutation({
    ...options.create,
    keysToInvalidateOnSuccess: (variable) => [
      ConnectQueryKeys.jobs.list(variable.type),
    ],
    mutationFn: (variables) => {
      const formData = new FormData();
      formData.append('file', variables.file, variables.file.name);

      return callCoreApi<ISuccessApiResponse>(
        `/tenants/api/wtb/tenants/${tenantCode}/${JOBS_ENDPOINT[variables.type]}`,
        {
          body: formData,
          method: 'POST',
          asJson: false,
        },
      );
    },
  });

  return restrictApi(options, {
    create: createMutation,
  });
};
